module.exports = __webpack_public_path__ + "img/clock.3ed6a346.svg";